import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import { AreaPage, SubPage } from "@/components/pages/AreaPage";
import { DoctorPage, StaffPage } from "@/components/pages/DoctorStaffPages";
import { ContactPage } from "@/components/pages/ContactPage";
import { ApprofondimentiPage, ArticlePage } from "@/components/pages/Approfondimenti";
import { RisultatiPage } from "@/components/pages/RisultatiPage";
import { CasePage } from "@/components/pages/CasePage";
import { DaDoveIniziare } from "@/components/pages/DaDoveIniziare";
import { PrivacyPage, CookiePolicyPage, NotFoundPage } from "@/components/pages/LegalPages";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Landing />} />
          <Route path="/dott-alessandro-valle" element={<DoctorPage />} />
          <Route path="/studio-staff" element={<StaffPage />} />
          <Route path="/contatti" element={<ContactPage />} />
          <Route path="/approfondimenti" element={<ApprofondimentiPage />} />
          <Route path="/approfondimenti/:slug" element={<ArticlePage />} />
          <Route path="/da-dove-iniziare" element={<DaDoveIniziare />} />
          <Route path="/risultati" element={<RisultatiPage />} />
          <Route path="/risultati/:slug" element={<CasePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/:area" element={<AreaPage />} />
          <Route path="/:area/:sub" element={<SubPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
